import VueGtag from 'vue-gtag-next';
import { googleAnalyticeKey, googleAnalyticeGA4Key } from '@/constants/key';

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.use(VueGtag, {
    property: [
      { id: googleAnalyticeKey() },
      { id: googleAnalyticeGA4Key() }
    ]
  })
});